import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';
import { Container, Placeholder } from 'semantic-ui-react';

import AccelerateBanner from './AccelerateBanner';
import AccelerateItem from './AccelerateItem';
import { useBreakpoints } from '$app/common/utils/mediaQueries';

const CompanyList = ({ isFetching, data }) => {
  const { isSmDown } = useBreakpoints();

  const CompanyListLoader = Array.from(Array(9).keys()).map(key => (
    <Grid item xs={12} md={6} lg={4} key={key}>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '20px',
          background: '#ffffff',
          boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.15)',
          borderRadius: 10,
          padding: 30,
        }}
      >
        <div
          css={{
            display: 'flex',
            alignIems: 'center',
            marginBottom: 20,
          }}
        >
          <div
            css={{
              display: 'flex',
            }}
          >
            <div css={{ display: 'flex' }}>
              <Placeholder
                style={{ height: 45, width: 45, borderRadius: '50%' }}
              >
                <Placeholder.Image />
              </Placeholder>
            </div>
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                marginLeft: '16px',
                flex: 1,
              }}
            >
              <div
                css={{
                  display: 'flex',
                }}
              >
                <Placeholder
                  fluid
                  css={{
                    '&&&.ui.fluid.placeholder': {
                      width: 150,
                    },
                  }}
                >
                  <Placeholder.Line />
                </Placeholder>
              </div>
              <Placeholder
                fluid
                css={{
                  '&&&.ui.fluid.placeholder': {
                    width: 80,
                  },
                }}
              >
                <Placeholder.Line />
              </Placeholder>
            </div>
          </div>
        </div>
        <Placeholder fluid>
          <Placeholder.Line />
        </Placeholder>
      </div>
    </Grid>
  ));

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background:
          "url('https://images.snaphunt.com/assets/images/company-list-page-bg.png')",
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        height: '100%',
        position: 'relative',
        padding: isSmDown ? '0 20px' : 0,
      }}
    >
      <Container
        css={{
          marginTop: isSmDown ? 180 : 330,
          zIndex: 1,
        }}
      >
        <Grid container spacing={3}>
          {isFetching
            ? CompanyListLoader
            : data?.map(accelerate => (
                <Grid item xs={12} md={6} lg={4} key={accelerate?.name}>
                  <AccelerateItem {...accelerate} />
                </Grid>
              ))}
        </Grid>
      </Container>
      <div
        css={{
          width: '100%',
          maxWidth: 1240,
          position: 'absolute',
          top: isSmDown ? 50 : 75,
          zIndex: 0,
          padding: isSmDown ? '0 30px' : 0,
        }}
      >
        <AccelerateBanner />
      </div>
    </div>
  );
};

CompanyList.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default CompanyList;
